import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, getResetByTag, utilityStyles, typography } from './../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("align-items:baseline;color:", colors.navy_500, ";display:inline-flex;font-weight:", typography.typographyFontWeightSemiBold, ";line-height:0.8;position:relative;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var isInverseStyles = function isInverseStyles(_ref) {
  var isInverse = _ref.isInverse,
    color = _ref.color;
  if (isInverse) {
    return /*#__PURE__*/css("color:", color === 'green' ? colors.green_300 : colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isInverseStyles;"));
  }
};
var resetStyles = getResetByTag('span');
var StyledPrice = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e178fubo0"
} : {
  target: "e178fubo0",
  label: "StyledPrice"
})(resetStyles, defaultStyles, isInverseStyles, utilityStyles);
export default StyledPrice;